import { ENABLE_I18N } from '@src/config/env'
import { DEFAULT_COUNTRY, SUPPORTED_COUNTRIES } from '@src/config/localisation/locale-config.constants'
import type { TCountry } from '@src/config/localisation/locale-config.types'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

/** Check if country matches the default country (generalized helper) */
export const isDefaultCountry = (country: TCountry) => country.toLowerCase() === DEFAULT_COUNTRY.toLowerCase()

/** Check if country is a non-default supported country (generalized helper) */
export const isNonDefaultCountry = (country: TCountry) => {
  const defaultCountry = DEFAULT_COUNTRY.toLowerCase()
  return country.toLowerCase() !== defaultCountry && SUPPORTED_COUNTRIES.includes(country.toLowerCase() as TCountry)
}

/** @deprecated Use isDefaultCountry instead - kept for backward compatibility */
export const isCountryUS = (country: TCountry) => isDefaultCountry(country)

/** @deprecated Use isNonDefaultCountry instead - kept for backward compatibility */
export const isCountryCanada = (country: TCountry) => isNonDefaultCountry(country)

export const getBFFApiVersion = (isI18nPreviewEnabled: boolean, apiVersion?: string) => {
  if (apiVersion === 'v3') {
    return 'v3'
  }
  if (isI18nPreviewEnabled) {
    return 'v2'
  } else {
    return 'v1'
  }
}

export function shouldEnableI18nServer(): boolean {
  return ENABLE_I18N
}

export function shouldEnableI18nClient(): boolean {
  if (!isBrowser()) return false
  return ENABLE_I18N
}
